





























































import { Component, Mixins } from "vue-property-decorator";
import { IOrg } from "@/models/organisation";
import { IState } from "@/store";
import HasValidation from "@/mixins/HasValidation";

@Component
export default class UpmindAssistControl extends Mixins(HasValidation) {
  public form: Partial<IOrg> = {};
  public isProcessing = false;

  public get relativeExpiryDate() {
    const { upmind_impersonation_expiry } = this.form;
    if (!upmind_impersonation_expiry) return "";
    return this.$moment
      .utc(upmind_impersonation_expiry)
      .local()
      .from(this.$moment.now());
  }

  public created() {
    this.initForm();
  }

  public initForm() {
    this.form = { ...(this.$store.state as IState).org.data };
  }

  public onToggle(isEnabled) {
    if (isEnabled) this.form.upmind_impersonation_expiry = null;
    this.validateBeforeSubmit();
  }

  public async validateBeforeSubmit() {
    try {
      this.isProcessing = true;
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      await this.$store.dispatch("org/update", {
        orgId: (this.$store.state as IState)?.user?.org_id,
        data: this.form
      });
      this.$store.dispatch("toast/show", {
        message: this.$t("_.remote_access_updated")
      });
    } catch (error) {
      this.initForm();
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
